import { useState } from "react";
import PageHero from "../components/PageHero";
import EnquiryForm from "@/components/feature/EnquiryForm";
import { DESTINATION_NAMES } from "@/pages/public/destinations/data";

interface Project {
  id: number;
  slug: string;
  name: string;
  location: string;
  state: string;
  region: "South India" | "North India" | "West India";
  status: "Under Construction" | "Ready to Stay" | "Coming Soon";
  villas: number;
  startPrice: string;
  roi: string;
  image: string;
}

const PROJECTS: Project[] = [
  {
    id: 1,
    slug: "coffee-trail-villas",
    name: "Coffee Trail Villas",
    location: "Coorg",
    state: "Karnataka",
    region: "South India",
    status: "Under Construction",
    villas: 24,
    startPrice: "₹78 L",
    roi: "32%",
    image: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20wooden%20A-frame%20villas%20nestled%20among%20coffee%20plantations%20in%20Coorg%2C%20rolling%20green%20hills%2C%20misty%20morning%20light%2C%20stylized%20artistic%20render%2C%20warm%20green%20and%20gold%20tones%2C%20premium%20hospitality%20photography%2C%20high%20detail&width=800&height=560&seq=loc-coorg-01&orientation=landscape",
  },
  {
    id: 2,
    slug: "misty-peaks-retreat",
    name: "Misty Peaks Retreat",
    location: "Munnar",
    state: "Kerala",
    region: "South India",
    status: "Ready to Stay",
    villas: 18,
    startPrice: "₹92 L",
    roi: "30%",
    image: "https://readdy.ai/api/search-image?query=Scenic%20A-frame%20wooden%20villas%20in%20Munnar%20hills%20with%20tea%20gardens%20and%20misty%20valleys%2C%20triangular%20glass%20windows%20glowing%20warm%2C%20golden%20morning%20light%2C%20stylized%20artistic%20render%2C%20high%20detail&width=800&height=560&seq=loc-munnar-02&orientation=landscape",
  },
  {
    id: 3,
    slug: "wayanad-glades",
    name: "Wayanad Glades",
    location: "Wayanad",
    state: "Kerala",
    region: "South India",
    status: "Under Construction",
    villas: 16,
    startPrice: "₹68 L",
    roi: "33%",
    image: "https://readdy.ai/api/search-image?query=Modern%20modular%20A-frame%20villas%20set%20among%20lush%20Wayanad%20forest%20canopy%2C%20waterfall%20in%20background%2C%20soft%20morning%20fog%2C%20warm%20green%20and%20earthy%20tones%2C%20stylized%20artistic%20render%2C%20high%20detail&width=800&height=560&seq=loc-wayanad-03&orientation=landscape",
  },
  {
    id: 4,
    slug: "highland-estate",
    name: "Highland Estate",
    location: "Ooty",
    state: "Tamil Nadu",
    region: "South India",
    status: "Coming Soon",
    villas: 20,
    startPrice: "₹84 L",
    roi: "29%",
    image: "https://readdy.ai/api/search-image?query=A-frame%20wooden%20villas%20on%20a%20green%20highland%20meadow%20in%20Ooty%20with%20eucalyptus%20trees%20and%20rolling%20hills%2C%20golden%20afternoon%20light%2C%20stylized%20artistic%20render%2C%20warm%20tones%2C%20high%20detail&width=800&height=560&seq=loc-ooty-04&orientation=landscape",
  },
  {
    id: 5,
    slug: "valley-view-cottages",
    name: "Valley View Cottages",
    location: "Lonavala",
    state: "Maharashtra",
    region: "West India",
    status: "Under Construction",
    villas: 22,
    startPrice: "₹72 L",
    roi: "31%",
    image: "https://readdy.ai/api/search-image?query=Wooden%20A-frame%20cottages%20in%20Lonavala%20hills%20overlooking%20a%20misty%20valley%20lake%2C%20evening%20warm%20light%2C%20stylized%20artistic%20render%2C%20earthy%20green%20and%20amber%20tones%2C%20high%20detail&width=800&height=560&seq=loc-lonavala-05&orientation=landscape",
  },
  {
    id: 6,
    slug: "sea-breeze-villas",
    name: "Sea Breeze Villas",
    location: "Dapoli",
    state: "Maharashtra",
    region: "West India",
    status: "Ready to Stay",
    villas: 14,
    startPrice: "₹66 L",
    roi: "30%",
    image: "https://readdy.ai/api/search-image?query=Coastal%20A-frame%20villas%20on%20a%20palm-fringed%20Konkan%20beach%20in%20Dapoli%2C%20turquoise%20sea%20and%20golden%20sand%2C%20bright%20daylight%2C%20stylized%20artistic%20render%2C%20warm%20tropical%20tones%2C%20high%20detail&width=800&height=560&seq=loc-dapoli-06&orientation=landscape",
  },
  {
    id: 7,
    slug: "mango-grove-resort",
    name: "Mango Grove Resort",
    location: "North Goa",
    state: "Goa",
    region: "West India",
    status: "Ready to Stay",
    villas: 15,
    startPrice: "₹88 L",
    roi: "28%",
    image: "https://readdy.ai/api/search-image?query=Boutique%20A-frame%20villas%20in%20a%20mango%20grove%20in%20North%20Goa%20with%20tropical%20plants%20and%20hammocks%2C%20relaxed%20warm%20daylight%2C%20stylized%20artistic%20render%2C%20green%20and%20sandy%20tones%2C%20high%20detail&width=800&height=560&seq=loc-goa-07&orientation=landscape",
  },
  {
    id: 8,
    slug: "lake-palace-village",
    name: "Lake Palace Village",
    location: "Udaipur",
    state: "Rajasthan",
    region: "North India",
    status: "Coming Soon",
    villas: 19,
    startPrice: "₹94 L",
    roi: "29%",
    image: "https://readdy.ai/api/search-image?query=A-frame%20villas%20near%20Udaipur%20lake%20palace%20with%20heritage%20stone%20architecture%20and%20warm%20sunset%20glow%2C%20golden%20and%20terracotta%20tones%2C%20stylized%20artistic%20render%2C%20high%20detail&width=800&height=560&seq=loc-udaipur-08&orientation=landscape",
  },
  {
    id: 9,
    slug: "ganga-view-cottages",
    name: "Ganga View Cottages",
    location: "Rishikesh",
    state: "Uttarakhand",
    region: "North India",
    status: "Under Construction",
    villas: 26,
    startPrice: "₹76 L",
    roi: "34%",
    image: "https://readdy.ai/api/search-image?query=Wooden%20A-frame%20cottages%20on%20a%20riverbank%20in%20Rishikesh%20overlooking%20the%20Ganga%2C%20Himalayan%20foothills%20and%20mist%2C%20warm%20morning%20light%2C%20stylized%20artistic%20render%2C%20high%20detail&width=800&height=560&seq=loc-rishikesh-09&orientation=landscape",
  },
  {
    id: 10,
    slug: "pine-ridge-villas",
    name: "Pine Ridge Villas",
    location: "Shimla",
    state: "Himachal Pradesh",
    region: "North India",
    status: "Coming Soon",
    villas: 17,
    startPrice: "₹90 L",
    roi: "31%",
    image: "https://readdy.ai/api/search-image?query=Alpine%20A-frame%20wooden%20villas%20among%20pine%20forests%20in%20Shimla%20with%20snow-capped%20mountains%20beyond%2C%20crisp%20blue%20daylight%2C%20stylized%20artistic%20render%2C%20cool%20and%20warm%20balance%2C%20high%20detail&width=800&height=560&seq=loc-shimla-10&orientation=landscape",
  },
];

const REGIONS = ["All", "South India", "West India", "North India"] as const;

const STATUS_STYLES: Record<Project["status"], string> = {
  "Under Construction": "bg-accent-100 text-accent-900",
  "Ready to Stay": "bg-primary-100 text-primary-800",
  "Coming Soon": "bg-secondary-100 text-secondary-900",
};

export default function Projects() {
  const [region, setRegion] = useState<(typeof REGIONS)[number]>("All");

  const visible = PROJECTS.filter((p) => region === "All" || p.region === region);

  return (
    <div className="w-full">
      <PageHero
        eyebrow="Projects & Destinations"
        title={
          <>
            Where Nomad Livings Villas Are <span className="italic text-accent-300">Being Built</span>
          </>
        }
        subtitle="From misty coffee hills in Coorg to Himalayan riverbanks in Rishikesh — explore our growing portfolio of modular A-frame villa projects across India."
      />

      {/* Stats strip */}
      <section className="w-full -mt-1 py-10 md:py-12 bg-background-100">
        <div className="w-full px-4 md:px-8 max-w-6xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-5">
          {[
            { value: "10+", label: "Active & Upcoming Projects", icon: "ri-building-line" },
            { value: "190+", label: "Villas in the Portfolio", icon: "ri-home-4-line" },
            { value: "3", label: "Regions Across India", icon: "ri-global-line" },
            { value: "₹66 L", label: "Entry Investment", icon: "ri-hand-coin-line" },
          ].map((s) => (
            <div
              key={s.label}
              className="flex flex-col sm:flex-row items-center sm:items-center gap-3 rounded-2xl bg-background-50 border border-background-200 p-4"
            >
              <span className="flex items-center justify-center w-11 h-11 rounded-full bg-accent-100 text-accent-700 shrink-0">
                <i className={`${s.icon} text-xl`}></i>
              </span>
              <div className="text-center sm:text-left">
                <p className="font-heading text-2xl text-foreground-950 leading-none">{s.value}</p>
                <p className="text-xs text-foreground-600 mt-1">{s.label}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Projects grid */}
      <section className="w-full py-12 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">Our Projects</h2>
              <p className="text-sm text-foreground-600 mt-1">
                Tap a project to view its full details, specs, brochure and enquiry options.
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              {REGIONS.map((r) => (
                <button
                  key={r}
                  onClick={() => setRegion(r)}
                  className={`text-sm font-medium whitespace-nowrap rounded-full px-4 py-2 transition-colors ${
                    region === r
                      ? "bg-primary-600 text-background-50"
                      : "bg-background-100 text-foreground-700 hover:bg-background-200"
                  }`}
                >
                  {r}
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {visible.map((p) => (
              <article
                key={p.id}
                className="group rounded-2xl bg-background-100 border border-background-200 overflow-hidden hover:border-primary-300 hover:-translate-y-0.5 transition-all duration-300"
              >
                <div className="relative h-52 w-full overflow-hidden">
                  <img
                    src={p.image}
                    alt={`${p.name} — ${p.location}, ${p.state}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <span
                    className={`absolute top-3 left-3 rounded-full px-3 py-1 text-[11px] font-semibold ${STATUS_STYLES[p.status]}`}
                  >
                    {p.status}
                  </span>
                </div>
                <div className="p-5">
                  <div className="flex items-start justify-between gap-2">
                    <div>
                      <h3 className="font-heading text-lg text-foreground-950">{p.name}</h3>
                      <p className="flex items-center gap-1.5 text-sm text-foreground-600 mt-1">
                        <i className="ri-map-pin-2-line text-primary-600"></i>
                        {p.location}, {p.state}
                      </p>
                    </div>
                    <span className="text-[11px] font-semibold uppercase tracking-wide text-accent-700 bg-accent-100 rounded-full px-2.5 py-1 whitespace-nowrap">
                      {p.region}
                    </span>
                  </div>

                  <div className="mt-4 grid grid-cols-3 gap-2 text-center">
                    <div className="rounded-xl bg-background-50 border border-background-200 py-2.5">
                      <p className="text-xs font-bold text-foreground-950">{p.villas}</p>
                      <p className="text-[10px] text-foreground-600">Villas</p>
                    </div>
                    <div className="rounded-xl bg-background-50 border border-background-200 py-2.5">
                      <p className="text-xs font-bold text-foreground-950">{p.startPrice}</p>
                      <p className="text-[10px] text-foreground-600">Starts At</p>
                    </div>
                    <div className="rounded-xl bg-accent-50 border border-accent-200 py-2.5">
                      <p className="text-xs font-bold text-accent-800">{p.roi}</p>
                      <p className="text-[10px] text-foreground-600">Est. ROI</p>
                    </div>
                  </div>

                  <a
                    href={`/projects/${p.slug}`}
                    className="mt-4 inline-flex w-full items-center justify-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full border border-primary-600 text-primary-700 px-4 py-2.5 hover:bg-primary-600 hover:text-background-50 transition-colors"
                  >
                    More Details <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </article>
            ))}
          </div>

          {visible.length === 0 && (
            <div className="text-center py-16">
              <i className="ri-map-pin-4-line text-4xl text-foreground-400"></i>
              <p className="text-foreground-600 mt-4">No projects in this region yet.</p>
            </div>
          )}

          {/* CTA */}
          <div className="mt-12 rounded-3xl bg-primary-800 text-background-100 overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <div className="p-6 md:p-10 flex flex-col justify-center">
                <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.22em] uppercase text-accent-300">
                  <i className="ri-compass-3-line"></i> Find Your Villa
                </span>
                <h3 className="font-heading text-2xl md:text-3xl text-background-50 mt-3">
                  New Land Banks Opening Soon
                </h3>
                <p className="text-sm text-background-200/90 mt-3 leading-relaxed">
                  We're actively scouting hospitality hotspots — hill stations, coastal towns and
                  nature getaways — for the next phase of projects. Get early access to launch
                  pricing and reserved villa slots.
                </p>
                <div className="mt-6 flex flex-col sm:flex-row gap-3">
                  <a
                    href="/investment-guide"
                    className="inline-flex items-center justify-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full bg-accent-500 text-background-50 px-6 py-3 hover:bg-accent-600 transition-colors"
                  >
                    Download Investment Guide <i className="ri-download-2-line"></i>
                  </a>
                  <a
                    href="tel:8088330330"
                    className="inline-flex items-center justify-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full border border-background-50/50 text-background-50 px-6 py-3 hover:bg-background-50 hover:text-primary-800 transition-colors"
                  >
                    <i className="ri-phone-fill"></i> 80883 30330
                  </a>
                </div>
              </div>
              <div className="relative min-h-[260px] lg:min-h-full w-full">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20illustrated%20map%20of%20India%20with%20glowing%20golden%20location%20pins%20marking%20villa%20resort%20projects%2C%20soft%20warm%20earth%20tones%20on%20a%20deep%20green%20background%2C%20modern%20flat%20illustration%2C%20premium%20hospitality%20branding%2C%20high%20detail&width=900&height=620&seq=loc-cta-map-11&orientation=landscape"
                  alt="Nomad Livings project locations across India"
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Enquire section */}
      <section className="w-full py-12 md:py-16 bg-background-100">
        <div className="w-full px-4 md:px-8 max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-start">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-accent-600">
              <i className="ri-mail-send-line"></i> Get Started
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mt-4 leading-tight">
              Enquire About a <span className="italic text-primary-700">Project</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mt-4 leading-relaxed">
              Tell us which project caught your eye and our investment advisors will share
              pricing, returns and site-visit options for your shortlisted locations.
            </p>

            <div className="mt-8 space-y-4">
              <a
                href="tel:8088330330"
                className="flex items-center gap-4 rounded-2xl bg-background-50 border border-background-200 p-4 hover:border-primary-300 transition-colors"
              >
                <span className="flex items-center justify-center w-11 h-11 rounded-full bg-primary-100 text-primary-700">
                  <i className="ri-phone-fill text-xl"></i>
                </span>
                <span>
                  <span className="block text-[11px] uppercase tracking-wide text-foreground-600">Call / WhatsApp</span>
                  <span className="block text-base font-bold text-foreground-950">80883 30330</span>
                </span>
              </a>
              <div className="flex items-center gap-4 rounded-2xl bg-background-50 border border-background-200 p-4">
                <span className="flex items-center justify-center w-11 h-11 rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-time-line text-xl"></i>
                </span>
                <span>
                  <span className="block text-[11px] uppercase tracking-wide text-foreground-600">Response Time</span>
                  <span className="block text-base font-bold text-foreground-950">Within 24 hours</span>
                </span>
              </div>
            </div>
          </div>

          <div className="rounded-3xl bg-background-50 border border-background-200 p-5 md:p-8">
            <EnquiryForm
              page="projects"
              title="Project Enquiry"
              subtitle="No obligation. A dedicated advisor will guide you through pricing, returns and the purchase journey."
              interestOptions={[
                "Staycation / Weekend Villa",
                "Airbnb / Short-Term Rental",
                "Boutique Resort Villa",
                "Holiday Home",
                "NRI Passive Income",
                "Not sure yet",
              ]}
              destinationOptions={DESTINATION_NAMES}
              ctaLabel="Send Project Enquiry"
            />
          </div>
        </div>
      </section>
    </div>
  );
}